import { render } from "./AARRRMetricsSection.vue?vue&type=template&id=2d377af4&scoped=true"
import script from "./AARRRMetricsSection.vue?vue&type=script&lang=js"
export * from "./AARRRMetricsSection.vue?vue&type=script&lang=js"

import "./AARRRMetricsSection.vue?vue&type=style&index=0&id=2d377af4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d377af4"]])

export default __exports__